import Spinners from "components/Shared/Spinners"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import {
  candidateAcceptPractical,
  getCandidatePracticalTrainingAvailable,
} from "store/actions/jobApplicationAction"
import { showAlert } from "store/reducers/alertReducer"
import StartAssessment from "./StartAssessment"
import ViewAssessment from "./ViewAssessment"

const CandidatePracticleTraining = () => {
  const {
    loading,
    candidatesPracticalAvailable,
    has_assessment_details,
    assessment_details,
  } = useSelector(state => state.JobApplication)

  const navigate = useNavigate()
  const { t } = useTranslation()
  document.title = t("Candidate | Yamama")
  const dispatch = useDispatch()
  const [selectedUuid, setSelectedUuid] = useState(null)
  const [selectedItem, setSelectedItem] = useState({})
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)
  const [modal1, setModal1] = useState(false)
  const [modalType, setModalType] = useState(null)
  const toggle1 = () => setModal1(!modal1)
  useEffect(() => {
    getAllData()
  }, [])

  const getAllData = () => {
    dispatch(getCandidatePracticalTrainingAvailable())
  }

  const handleAcceptReject = () => {
    const payload = {
      training_uuid: selectedUuid,
    }
    dispatch(candidateAcceptPractical(payload))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          setSelectedUuid(null)
          setModal(null)
          getAllData()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <Col xl="12">
                <h4 className="card-title mb-4">
                  {t("My Practical Training")}
                </h4>
                <Card className="user_personal_info theme_card overflow-x-auto">
                  <CardBody>
                    <Table className="table mb-0 table-responsive">
                      <thead className="table-light full_th">
                        <tr>
                          <th>{t("S. No.")}</th>
                          <th>{t("Training Name")}</th>
                          <th>{t("Station")}</th>
                          <th>{t("Site")}</th>
                          <th>{t("Duration (Hours)")}</th>
                          {/* <th>{t("Capacity")}</th> */}
                          {/* <th>{t("Participated")}</th> */}
                          <th>{t("Date")}</th>
                          <th>{t("Time")}</th>
                          {has_assessment_details && (
                            <>
                              {/* <th>{t("Attended")}</th> */}
                              <th>{t("Attended Days")}</th>
                              <th>{t("Attended Dates")}</th>
                            </>
                          )}
                          <th>{t("Action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {candidatesPracticalAvailable?.map((item, index) => (
                          <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{item?.name}</td>
                            <td>{item?.station || "-"}</td>
                            <td>{item?.site || "-"}</td>
                            <td>{item?.duration || "-"}</td>
                            {/* <td>{item?.trainees_each_group ?? "-"}</td> */}
                            {/* <td>{item?.participants_count ?? "-"}</td> */}
                            <td>
                              <p className="fit_content">
                                {item?.start_date} ~ {item?.end_date}
                              </p>
                            </td>
                            <td>
                              <p className="fit_content">
                                {item?.start_time} ~ {item?.end_time}
                              </p>
                            </td>
                            {has_assessment_details && (
                              <>
                                {/* <td>
                                  {assessment_details?.is_attended
                                    ? t("Yes")
                                    : t("No")}
                                </td> */}
                                <td>{assessment_details?.attended_days}</td>
                                <td>
                                  <p style={{ maxWidth: 100 }}>
                                    {assessment_details?.attended_dates?.dates?.join(
                                      ", "
                                    )}
                                  </p>
                                </td>
                              </>
                            )}
                            <td>
                              <div className="d-flex gap-3 action_buttons">
                                {item?.can_enroll && (
                                  <Button
                                    color="primary"
                                    className="fit_content"
                                    onClick={() => {
                                      toggle()
                                      setSelectedUuid(item?.uuid)
                                      setSelectedItem(item)
                                    }}
                                  >
                                    {t("Accept")}
                                  </Button>
                                )}
                                {item?.can_submit_assessment && (
                                  <Button
                                    color="primary"
                                    className="fit_content"
                                    onClick={() => {
                                      toggle1()
                                      setSelectedUuid(item?.uuid)
                                      setSelectedItem(item)
                                      setModalType("START_INTERVIEW")
                                    }}
                                  >
                                    {t("Start Assessment")}
                                  </Button>
                                )}
                                {assessment_details?.is_submitted && (
                                  <Button
                                    color="primary"
                                    className="fit_content"
                                    onClick={() => {
                                      toggle1()
                                      setSelectedUuid(item?.uuid)
                                      setSelectedItem(item)
                                      setModalType("VIEW_INTERVIEW")
                                    }}
                                  >
                                    {t("View Assessment")}
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        )}
      </div>
      <Modal isOpen={modal} toggle={toggle} size="md" backdrop="static">
        <ModalHeader toggle={toggle}>
          {t("Accept Practical Training")}
        </ModalHeader>
        <ModalBody>
          <div className="row g-2">
            <h4>{t("Are you sure you want to confirm this date and time")}</h4>
            <h5>
              {t("Date")}: {selectedItem?.start_date} ~ {selectedItem?.end_date}
            </h5>
            <h5>
              {t("Time")}: {selectedItem?.start_time} ~ {selectedItem?.end_time}
            </h5>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
          <Button color="primary" onClick={handleAcceptReject}>
            Accept
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={modal1}
        toggle={toggle1}
        className="full_screen_modal"
        backdrop="static"
      >
        <ModalHeader toggle={toggle1}>
          {modalType === "START_INTERVIEW"
            ? t("Start Assessment")
            : t("View Assessment Details")}
        </ModalHeader>
        {modalType === "START_INTERVIEW" && (
          <StartAssessment
            selectedItem={selectedItem}
            toggle1={toggle1}
            getAllData={getAllData}
          />
        )}
        {modalType === "VIEW_INTERVIEW" && (
          <ViewAssessment
            selectedItem={selectedItem}
            toggle1={toggle1}
            getAllData={getAllData}
          />
        )}
      </Modal>
    </React.Fragment>
  )
}

export default CandidatePracticleTraining
